export default "__VITE_PUBLIC_ASSET__1657afc9__"